module.exports = __webpack_public_path__ + "img/popup_mama_2026.3e609387.jpg";